import {
  LabelInput,
  EntryTypeSelect,
  RequiredToggle,
  StandardDesignConfig,
  HideOnPdfToggle,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

export const DropDownStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  RequiredToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
